export const URLS = {
    master: {
      getAllLookupTable: "app/master/getAllLookupTable",
      getAllLookupValue: "app/master/getAllLookupValue",
      insertUpdateLookupValue: "app/master/insertUpdateLookupValue",
      deleteLookupValue: "app/master/deleteLookupValue",
      updateMasterTagsStatus: "app/master/updateLookupValueStatus",
      getAllMasterTags: "app/masterTags/getAllMasterTags",
      insertMasterTags: "app/masterTags/insertMasterTags",
      updateMasterTags: "app/masterTags/updateMasterTags",
      deleteMasterTags: "app/masterTags/deleteMasterTags",
    },
    warehouse: {
      updateWarehouseStatus: "app/warehouse/updateWarehouseStatus",
      getAllWarehouse: "app/warehouse/getAllWarehouse",
      insertWarehouse: "app/warehouse/insertWarehouse",
      updateWarehouse: "app/warehouse/updateWarehouse",
      deleteWarehouse: "app/warehouse/deleteWarehouse",
    },
    billingTerms: {
      updateBillingTermsStatus: "app/billingTerms/updateBillingTermsStatus",
      getAllBillingTermsManagement: "app/billingTerms/getAllBillingTermsManagement",
      insertBillingTerms: "app/billingTerms/insertBillingTerms",
      updateBillingTerms: "app/billingTerms/updateBillingTerms",
      deleteBillingTerms: "app/billingTerms/deleteBillingTerms",
    },
    vendorLeadTime: {
      updateVendorLeadTimeStatus: "app/vendorLeadTime/updateVendorLeadTimeStatus",
      getAllVendorLeadTime: "app/vendorLeadTime/getAllVendorLeadTime",
      insertVendorLeadTime: "app/vendorLeadTime/insertVendorLeadTime",
      updateVendorLeadTime: "app/vendorLeadTime/updateVendorLeadTime",
      deleteVendorLeadTime: "app/vendorLeadTime/deleteVendorLeadTime",
    },
    customerLeadTime: {
      updateCustomerLeadTimeStatus: "app/customerLeadTime/updateCustomerLeadTimeStatus",
      getAllCustomerLeadTime: "app/customerLeadTime/getAllCustomerLeadTime",
      insertCustomerLeadTime: "app/customerLeadTime/insertCustomerLeadTime",
      updateCustomerLeadTime: "app/customerLeadTime/updateCustomerLeadTime",
      deleteCustomerLeadTime: "app/customerLeadTime/deleteCustomerLeadTime",
    },
    currency: {
      updateCurrencyStatus: "app/currency/updateCurrencyStatus",
      getAllCurrency: "app/Currency/getAllCurrency",
      insertCurrencyInfo: "app/currency/insertCurrencyInfo",
      updateCurrencyInfo: "app/currency/updateCurrencyInfo",
      deleteCurrencyInfo: "app/currency/deleteCurrencyInfo",
    },
    nCMCodeManagement: {
      updateNCMCodeStatus: "app/nCMCodeManagement/updateNCMCodeStatus",
      getAllNCMCodeManagement: "app/nCMCodeManagement/getAllNCMCodeManagement",
      insertNCMCodeManagementInfo: "app/nCMCodeManagement/insertNCMCodeManagementInfo",
      updateNCMCodeManagementInfo: "app/nCMCodeManagement/updateNCMCodeManagementInfo",
      deleteNCMCodeManagement: "app/nCMCodeManagement/deleteNCMCodeManagement",
    },
    userCommission: {
      updateUserCommissionStatus: "app/userCommission/updateUserCommissionStatus",
      getAllUserCommission: "app/userCommission/getAllUserCommission",
      insertCommission: "app/userCommission/insertCommission",
      updateCommission: "app/userCommission/updateCommission",
      deleteUserCommission: "app/userCommission/deleteUserCommission",
      deleteUserCommissionRange: "app/userCommission/deleteUserCommissionRange",
    },
    shippingProvider: {
      updateShippingProviderAndMethodStatus: "app/shippingProvider/updateShippingProviderAndMethodStatus",
      getAllShippingProvidersAndMethods: "app/shippingProvider/getAllShippingProvidersAndMethods",
      insertShippingProviders: "app/shippingProvider/insertShippingProviders",
      updateShippingProviders: "app/shippingProvider/updateShippingProviders",
      deleteShippingProviderOrMethod: "app/shippingProvider/deleteShippingProviderOrMethod",
    },
    manufacturer: {
      updateManufacturerStatus: "app/manufacturer/updateManufacturerStatus",
      getAllManufacturers: "app/manufacturer/getAllManufacturers",
      deleteManufacturer: "app/manufacturer/deleteManufacturer",
      deleteChildManufacturer: "app/manufacturer/deleteChildManufacturer",
      addManufacturer:"app/manufacturer/addManufacturer",
      updateManufacturer: "app/manufacturer/updateManufacturer",
      addRelatedEntityManufacturer:"app/manufacturer/addRelatedEntity",


    },
    scope: {
      getAllScopes: "SourceMatrixApi/Scope/GetAllScopes",
      insertUpdateScope: "SourceMatrixApi/Scope/InsertUpdateScope",
    },
    dropdown: {
        getAllManufacturerDropdown: "SourceMatrixApi/CompanyManufacturer/GetAllManufacturerDropDownList",
        
      }
  };
  